import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/svg/speaker-off.svg'
import _imports_1 from '@/assets/icons/svg/speaker.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex flex-row absolute z-20 bottom-5 w-full justify-end pr-12"
}
const _hoisted_2 = {
  id: "Layer_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 529.4 529.4"
}
const _hoisted_3 = { id: "Layer_1-2" }
const _hoisted_4 = ["fill"]
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<g id=\"Layer_2-3\"><g id=\"Layer_3\"><circle style=\"fill:#fff;\" class=\"st1\" cx=\"185.8\" cy=\"294.6\" r=\"52.6\"></circle><circle style=\"fill:#000;\" cx=\"185.8\" cy=\"294.6\" r=\"33.3\"></circle><circle style=\"fill:#fff;\" class=\"st1\" cx=\"344.7\" cy=\"294.6\" r=\"52.5\"></circle><circle style=\"fill:#000;\" cx=\"344.7\" cy=\"294.6\" r=\"33.3\"></circle><path style=\"fill:red;\" d=\"M264.6,351.5c29-0.1,54.2,19.8,60.9,48.1c1.3,5.9-2.5,11.7-8.4,13c-5.7,1.2-11.4-2.2-12.9-7.9\n\t\t\t\tc-5.3-21.9-27.3-35.4-49.3-30.2c-14.9,3.6-26.6,15.2-30.2,30.2c-1.5,5.8-7.5,9.3-13.4,7.8c-5.6-1.5-9.1-7.2-7.9-12.9\n\t\t\t\tC210.4,371.4,235.6,351.5,264.6,351.5L264.6,351.5z\"></path></g></g>", 1)
const _hoisted_6 = {
  class: "relative flex flex-col justify-center",
  style: {"width":"70vmin"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "absolute z-10 w-16 p-4 rounded-full",
  style: {"background-color":"#ff3e15","top":"20%","right":"20%"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "relative inline-block" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "w-6 h-6",
  src: _imports_0,
  alt: "close"
}
const _hoisted_13 = {
  key: 1,
  class: "w-6 h-6",
  src: _imports_1,
  alt: "close"
}
const _hoisted_14 = {
  key: 0,
  class: "absolute -top-8 left-4 w-full"
}
const _hoisted_15 = { class: "relative flex flex-row items-center" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  id: "Layer_2",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 529.4 529.4"
}
const _hoisted_18 = { id: "Layer_1-2" }
const _hoisted_19 = ["fill"]
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<g id=\"Layer_2-3\"><g id=\"Layer_3\"><circle style=\"fill:#fff;\" cx=\"185.8\" cy=\"174.6\" r=\"52.6\"></circle><circle style=\"fill:#000;\" cx=\"185.8\" cy=\"174.6\" r=\"33.3\"></circle><circle style=\"fill:#fff;\" class=\"cls-2\" cx=\"344.7\" cy=\"174.6\" r=\"52.5\"></circle><circle style=\"fill:#000;\" cx=\"344.7\" cy=\"174.6\" r=\"33.3\"></circle><path d=\"M264.3 299.9c-29 .1-54.2-19.8-60.9-48.1-1.3-5.9 2.5-11.7 8.4-13 5.7-1.2 11.4 2.2 12.9 7.9 5.3 21.9 27.3 35.4 49.3 30.2 14.9-3.6 26.6-15.2 30.2-30.2 1.5-5.8 7.5-9.3 13.4-7.8 5.6 1.5 9.1 7.2 7.9 12.9-7 28.2-32.2 48.1-61.2 48.1Z\" style=\"fill:red;\"></path></g></g>", 1)
const _hoisted_21 = {
  key: 0,
  class: "pointer-events-none text-lg text-white capitalize"
}
const _hoisted_22 = {
  class: "absolute w-full z-10 bottom-0",
  style: {"height":"20vh"}
}
const _hoisted_23 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "relative flex flex-row justify-center w-full h-full text-center text-white",
    style: _normalizeStyle({ backgroundColor: _ctx.backgroundColour })
  }, [
    (_ctx.mode === _ctx.MODES.intro)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Button, {
            backgroundcolour: 'bg-sl-green-button',
            textcolour: 'text-white',
            childclass: 'text-2xl border-none p-3 h-12',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickNextIntro()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('next')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.mode === _ctx.MODES.quizz)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "flex flex-col justify-center place-self-center rounded-full p-4 mr-4",
          style: _normalizeStyle([{ backgroundColor: _ctx.downBackgroundColour }, {"width":"25vmin"}]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickAnswer(_ctx.Thumbs.down)))
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_2, [
            _createElementVNode("g", _hoisted_3, [
              _createElementVNode("circle", {
                id: "Layer_2-2",
                fill: _ctx.downForegroundColour,
                cx: "264.7",
                cy: "264.7",
                r: "264.7"
              }, null, 8 /* PROPS */, _hoisted_4),
              _hoisted_5
            ])
          ]))
        ], 4 /* STYLE */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "absolute pointer-events-none w-full bg-center bg-no-repeat",
        style: _normalizeStyle([{"bottom":"15%"}, { backgroundImage: 'url(' + _ctx.bgFishedImage + ')' }])
      }, [
        _createElementVNode("img", {
          src: _ctx.item.image,
          class: "p-24 md:p-32 lg:p-36",
          alt: "sea background image"
        }, null, 8 /* PROPS */, _hoisted_7)
      ], 4 /* STYLE */),
      _createCommentVNode(" Red X for Quizz mode "),
      (_ctx.mode === _ctx.MODES.quizz && _ctx.answeredCorrectly && _ctx.item.correctAnswer === _ctx.Thumbs.down)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("img", {
              src: _ctx.x,
              alt: "X icon - this item does not belong"
            }, null, 8 /* PROPS */, _hoisted_9)
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Text bubble "),
      _createElementVNode("div", {
        class: "absolute z-10 pointer-events-none w-full bg-center bg-no-repeat",
        style: _normalizeStyle([{"bottom":"10%"}, { backgroundImage: 'url(' + _ctx.bgTextImage + ')' }])
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createCommentVNode(" eslint-disable-next-line vue/no-v-html "),
          _createElementVNode("div", {
            class: "text-black text-lg md:text-2xl font-bold p-8 md:p-16",
            innerHTML: _ctx.boxText
          }, null, 8 /* PROPS */, _hoisted_11),
          _createCommentVNode(" Sound replay button "),
          _createVNode(_component_Button, {
            class: "absolute pointer-events-auto bg-white p-2 rounded-full top-0 right-0",
            childclass: 'w-12 h-12',
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.soundIsPlaying ? _ctx.stopSounds() : _ctx.playFishedItemSound()))
          }, {
            default: _withCtx(() => [
              (_ctx.soundIsPlaying)
                ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                : (_openBlock(), _createElementBlock("img", _hoisted_13))
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode(" Omar's lightbub placement for Word Focus mode "),
          (_ctx.mode === _ctx.MODES.wordFocus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("img", {
                    src: _ctx.lightBulb,
                    class: "z-10 w-16",
                    alt: "light bulb - word focus"
                  }, null, 8 /* PROPS */, _hoisted_16),
                  _createCommentVNode("div class=\"rounded-r-full p-3 text-center flex flex-col justify-center h-12 -m-6 -mt-2 pl-8 pr-6\" style=\"background-color: #48b6ff\">\n                <p class=\"uppercase font-bold\">{{ t('wordFocus') }}</p>\n              </div")
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ], 4 /* STYLE */)
    ]),
    (_ctx.mode === _ctx.MODES.quizz)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "flex flex-col z-10 justify-center place-self-center rounded-full p-4 -ml-10 md:-ml-12",
          style: _normalizeStyle([{"width":"25vmin"}, { backgroundColor: _ctx.upBackgroundColour }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickAnswer(_ctx.Thumbs.up)))
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_17, [
            _createElementVNode("g", _hoisted_18, [
              _createElementVNode("circle", {
                id: "Layer_2-2",
                fill: _ctx.upForegroundColour,
                cx: "264.7",
                cy: "264.7",
                r: "264.7"
              }, null, 8 /* PROPS */, _hoisted_19),
              _hoisted_20
            ])
          ])),
          _createCommentVNode("img\n        :style=\"{ color: upBackgroundColour }\"\n        :class=\"[upBackgroundColour ? 'fill-current' : '']\"\n        v-if=\"!answeredCorrectly || answeredCorrectly === Thumbs.up\"\n        :src=\"yes\"\n        alt=\"thumbs up image\"\n      /")
        ], 4 /* STYLE */))
      : _createCommentVNode("v-if", true),
    (_ctx.answeredCorrectly || _ctx.mode === _ctx.MODES.wordFocus)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "absolute bottom-5 z-20 right-6 rounded-full flex flex-col justify-center p-5 cursor-pointer",
          style: {"background-color":"#01c755"},
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickNext && _ctx.clickNext(...args)))
        }, [
          (_ctx.focusPage < _ctx.item.wordFocus.length - 1)
            ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.t('next')), 1 /* TEXT */))
            : _renderSlot(_ctx.$slots, "default", {
                key: 1,
                class: "pointer-events-none text-lg text-white capitalize"
              })
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("img", {
        src: _ctx.coralImage,
        class: "pointer-events-none h-full",
        alt: "coral background image"
      }, null, 8 /* PROPS */, _hoisted_23)
    ])
  ], 4 /* STYLE */))
}